import React, {FC} from "react";

interface SoccerProps {
  height: number,
  width: number
}

const Soccer: FC<SoccerProps> = (props) => {
  return <div className="soccer-ico" style={{height: props.height, width: props.width}} />
}

export default Soccer;